(function () {
  'use strict';

  // Quick-add modal içindeki thumbnail listesine yatay drag-to-scroll ekler.
  // Touch/swipe ve scroll-wheel zaten native olarak çalışır;
  // bu dosya desktop fare ile tutup-sürükleme deneyimini ekler.

  function attachDragScroll(list) {
    if (list.dataset.kgDragInit === '1') return;
    list.dataset.kgDragInit = '1';

    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;
    var moved = false;

    list.addEventListener('mousedown', function (e) {
      // İnteraktif element üzerinde drag başlatma — yine de click'i koru
      if (e.target.closest('button, a, input, [role="button"]')) {
        // Drag yine de çalışsın ama threshold geçilince click iptal edilsin
      }
      isDown = true;
      moved = false;
      startX = e.pageX - list.offsetLeft;
      scrollLeft = list.scrollLeft;
    });

    document.addEventListener('mouseup', function () {
      isDown = false;
    });

    list.addEventListener('mouseleave', function () {
      isDown = false;
    });

    list.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var x = e.pageX - list.offsetLeft;
      var walk = (x - startX) * 1.2;
      if (Math.abs(walk) > 4) {
        moved = true;
        list.scrollLeft = scrollLeft - walk;
        e.preventDefault();
      }
    });

    // Drag sonrası click'i engelle (yanlışlıkla thumbnail seçilmesin)
    list.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      },
      true
    );
  }

  function attachAll(root) {
    var lists = root.querySelectorAll('.thumbnail-list');
    for (var i = 0; i < lists.length; i++) {
      attachDragScroll(lists[i]);
    }
  }

  function init() {
    var modals = document.querySelectorAll('quick-add-modal');
    for (var i = 0; i < modals.length; i++) {
      var modal = modals[i];
      attachAll(modal);

      // Modal içeriği fetch edildikten sonra DOM'a eklenince tekrar bağla
      var observer = new MutationObserver(function (mutations) {
        for (var j = 0; j < mutations.length; j++) {
          var added = mutations[j].addedNodes;
          for (var k = 0; k < added.length; k++) {
            var node = added[k];
            if (node.nodeType === 1) {
              if (node.matches && node.matches('.thumbnail-list')) {
                attachDragScroll(node);
              } else if (node.querySelectorAll) {
                attachAll(node);
              }
            }
          }
        }
      });
      observer.observe(modal, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
